import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  Stack,
  Divider,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  List,
  ListItem,
  ListItemText,
  Paper,
  Modal,
} from "@mui/material";
import GestionTarea from "./GestionTarea";
import GestionComentario from "./GestionComentario";
import NewOportunidad from "./NewOportunidad";
import GestionCotizaciones from "../Cotizaciones/GestionCotizacion";
import { useAccesos } from '../contexts/AccesosContext';

const etapas = ["Abierta", "Cotizada", "Cerrada"];

function AddOportunidad ({handleSeleccionarOportunidad, selectOportunidad}) {
  const [etapaActual, setEtapaActual] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [tareas, setTareas] = useState(['']);
  const [comentarios, setComentarios] = useState(['']);
  const [mostrarCotizaciones, setMostrarCotizaciones] = useState(false);
  const [openCotizacion, setOpenCotizacion] = useState(false);
  const { tienePermiso } = useAccesos();

  const handleOpenCotizacion = () => setOpenCotizacion(true);
  const handleCloseCotizacion = () => setOpenCotizacion(false);

  
  
  const oportunidad = selectOportunidad || {};

  
  const renderInfo = (label, value) => (
    <Stack direction="row" spacing={2} justifyContent="space-between" mb={1}>
      <Typography variant="body2" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {value ?? "—"}
      </Typography>
    </Stack>
  );

  const handleAbrirModal = () => setOpenModal(true);
  const handleCerrarModal = () => setOpenModal(false);

  const handleGuardarOportunidad = () => {
    // Simular guardado
    console.log("Guardar nueva oportunidad");
    handleCerrarModal();
  };

  const renderEtapaCard = () => {
    const etapa = etapas[etapaActual];

    return (
      <Card elevation={4} sx={{ mt: 4, p: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Etapa: {etapa}
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {renderInfo("Nombre", oportunidad.nombreOportunidad)}
          {renderInfo("ID Cliente", oportunidad.idCliente)}
          {renderInfo("Origen", oportunidad.origen)}
          {renderInfo("Probabilidad", `${oportunidad.probabilidadOport}%`)}
          {renderInfo("Sucursal", oportunidad.sucursal)}


          {etapa === "Cotizada" && (
            <>
              <Divider sx={{ my: 2 }} />
              {renderInfo("ID Cotización", oportunidad.idCotizacion)}
              {renderInfo("Valor Monetario", `$${oportunidad.valorMonetario}`)}
              {renderInfo("Fecha tentativa de cierre", oportunidad.fechaCierre)}
              
            </>
          )}

          {etapa === "Cerrada" && (
            <>
              <Divider sx={{ my: 2 }} />
              {/* {renderInfo("Etapa", oportunidad.etapa)} */}
              {renderInfo("Fecha de cierre", oportunidad.fechaCierre)}
              {renderInfo("ID Orden", oportunidad.idOrden)}
            </>
          )}
        </CardContent>
      </Card>
    );
  };



  if (mostrarCotizaciones) {
    return <GestionCotizaciones />;
  }


  return (
    <Container maxWidth="xl" sx={{ mt: 6 }}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          width="100%"
          maxWidth={1200}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Button
            variant="contained"
            onClick={handleOpenCotizacion}
          >
            Nueva Cotizacion
          </Button>
          <Dialog open={openCotizacion} onClose={handleGuardarOportunidad} maxWidth="xl" fullWidth>
            <DialogContent>
              <GestionCotizaciones />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseCotizacion}>Cancelar</Button>
                {/* Puedes agregar un botón "Guardar" si lo necesitas */}
              </DialogActions>

          </Dialog>
          <Typography variant="h4">Seguimiento de Oportunidad</Typography>
          
          
          <Button
            variant="contained"
            onClick={handleAbrirModal}
            disabled={!tienePermiso('Crear Oportunidad')}
          >
            Nueva Oportunidad
          </Button>
          

        </Box>

        <Box sx={{ width: "100%", maxWidth: 1200 }}>
          <Tabs
            value={etapaActual}
            onChange={(e, newValue) => setEtapaActual(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {etapas.map((etapa) => (
              <Tab label={etapa} key={etapa} />
            ))}
          </Tabs>

          {renderEtapaCard()}

          <Box
          sx={{
            mt: 4,
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {/* Sección de Tareas */}
          <Paper
            elevation={3}
            sx={{ flex: 1, minWidth: "300px", p: 3 }}
          >
            
              <GestionTarea idOportunidad={selectOportunidad?.id} />
          </Paper>

          {/* Sección de Comentarios */}
              <Paper
                elevation={3}
                sx={{ flex: 1, minWidth: "300px", p: 3 }}
              >
                
                <GestionComentario idOportunidad={selectOportunidad?.id}/>
              </Paper>
            </Box>
        </Box>
      </Box>
      {/* Modal para nueva tarea */}
        <Dialog open={openModal} onClose={handleCerrarModal} maxWidth="md" fullWidth>
          <DialogTitle>Agregar Nueva Oportunidad</DialogTitle>
            <DialogContent>
              <NewOportunidad />
            </DialogContent>
          <DialogActions>
            <Button onClick={handleCerrarModal}>Cancelar</Button>
            
          </DialogActions>
        </Dialog>     
    </Container>
  );
}

export default AddOportunidad;